import * as qiniu from 'qiniu-js'
/*
 * @Author: 南枫
* @Date: 2020-12-30 14:50:48
 * @LastEditors: 南枫
 * @LastEditTime: 2021-08-19 10:00:58
 */

/**
 * post 请求方法
 * @param url
 * @param data
 * @return {Promise}
 */
export function QiniuUpload(qiniu_data, data) {
    let endName = String(data.file.name).split('.').pop()
    let timestamp = (new Date()).getTime();
    let putExtra = {
        fname: data.file.name,
        params: {},
        mimeType: null
    }
    let config = {
        useCdnDomain: false,
        region: null
    }
    return new Promise((resolve, reject) => {
        let num = 0;
        let observable = qiniu.upload(data.file, `${timestamp}.${endName}`, qiniu_data.uptoken, putExtra, config)
        observable.subscribe((res) => {
            num = res.total.percent;
        }, (err) => {
            reject(err);
        }, (res) => {
            if (num == 100) {
                resolve(res);
            }
        })

    })
}
